import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { DynamicComponentsModule } from '../../modules/dynamic-components/dynamic-components/dynamic-components.module';
import { ListModule } from '../list/list.module';
import { AccordionComponent } from './accordion/accordion.component';
import { AccordionsGroupComponent } from './accordions-group.component';

@NgModule({
  declarations: [AccordionsGroupComponent, AccordionComponent],
  imports: [
    CommonModule,
    TranslateModule,
    ListModule,
    DynamicComponentsModule
  ],
  exports: [AccordionsGroupComponent]
})
export class AccordionsGroupModule { }
